import getMainLocale from './main-locale';
import getCurrentHtmlLocale from './current-html-locale';
import getCurrentLocale from './current-locale';
import getSiteLocales from './site-locales';
import getPageLocaleById from './page-locale-by-id';
import getSupportedLocales from './supported-locales';

export default {
  getSiteLocales,
  getCurrentHtmlLocale,
  getCurrentLocale,
  getMainLocale,
  getPageLocaleById,
  getSupportedLocales,
};
